import { NativeModules } from 'react-native';

export interface GetAppsResponse {
  packageName: string;
  versionName: string;
  versionCode: string;
  firstInstallTime: string;
  lastUpdateTime: string;
  appName: string;
  icon: string;
  apkDir: string;
}

const getAppsOnDevice = (): Promise<GetAppsResponse[]> => {
  return NativeModules.AppDetailsModule.getApps();
};

export default getAppsOnDevice;
